'use cient';

import {
  createSmartObject,
  DynamicYieldScript,
} from '@sgcmpteltd/uikit-next/components/dynamic-yield-script';

import { dynamicYieldSectionId } from '@/configs/analytics';

import type { Component } from './types';

export const DYAds: Component = ({
  smartObjectId,
  target,
  size = [970, 90],
}) => (
  <>
    <DynamicYieldScript
      sectionId={dynamicYieldSectionId ?? ''}
      onScriptsLoad={() => {
        createSmartObject(smartObjectId, target);
      }} />
    <div
      id={target}
      style={{ width: size[0], height: size[1] }} />
  </>
);
